import Cookies from 'js-cookie'
import qs from 'qs'

export const isBlank = (obj) => {
  return !(obj && obj.length && obj.length > 0)
}

export const getQuery = () => {
  return qs.parse(document.location.search.split('?')[1])
}

export const saveTokenFromQuery = (token) => {
  Cookies.set('token', token, { expires: 7 })
  return token
}

export const assignQuery = (newQuery) => {
  const query = qs.parse(document.location.search.split('?')[1])
  return qs.stringify(Object.assign(query, newQuery))
}

export const getToken = () => {
  let { token } = getQuery()
  if (!isBlank(token)) {
    return saveTokenFromQuery(token)
  }
  token = Cookies.get('token')
  if (!isBlank(token)) {
    return token
  }
  return null
}

export const getAppId = (prefix = 'apps') => {
  let appId = null
  const reg = new RegExp(`\\/${prefix}\\/(\\d+)\\/.*`)
  const res = window.location.href.match(reg)
  appId = (res && res.length > 0 && res[1]) || null
  if (appId == null) {
    const query = qs.parse(document.location.search.replace('?', ''))
    return query.appId
  }
  return appId
}
